import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { IMockData, mockData } from '@fi-shared/fi-select-search/fi-select-search-multi-level/mockdata';
import {
    FiHierarchicalHelper,
    IFlatItem,
    ISelectSearchSelectedItemChange,
} from '@fi-shared/utils/fi-hierarchical-helper';

@Component({
    selector: 'fi-select-search-multi-level',
    templateUrl: './fi-select-search-multi-level.component.html',
    styleUrls: ['./fi-select-search-multi-level.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-select-search-multi-level' },
    standalone: false,
})
export class FiSelectSearchMultiLevelComponent implements OnInit {
    fiSelectSearchNgModel: number[] = [];
    fiSelectSearchHierarchicalHelper = new FiHierarchicalHelper<IMockData>((item: IMockData) => {
        return {
            id: item.Id,
            name: item.Name,
            childItems: item.ChildItems,
        };
    });

    constructor() {}

    ngOnInit() {
        this.fiSelectSearchHierarchicalHelper.setFlatItems(mockData);
    }

    selectedItemsChanged($event: ISelectSearchSelectedItemChange<IFlatItem<any>>) {
        this.fiSelectSearchNgModel = this.fiSelectSearchHierarchicalHelper.onSelectedItemChange({
            selectedItemIds: this.fiSelectSearchNgModel,
            changedItem: $event.item,
            isSelected: $event.isSelected,
        });
    }

    onCheckboxItemClick(item: IFlatItem<any>, isSelected: boolean) {
        // note: in fi-select-search component ngModel is changed on select option click.
        // since it doesn't happen initially on checkbox click - we need to do it ourselves.
        if (isSelected) {
            this.fiSelectSearchNgModel.push(item.Id);
        } else {
            const itemIndex: number = this.fiSelectSearchNgModel.findIndex((itemId: number) => itemId === item.Id);
            this.fiSelectSearchNgModel.splice(itemIndex, 1);
        }

        this.selectedItemsChanged({ item, isSelected });
    }
}
